import { render, staticRenderFns } from "./WorkbenchRichEditor.vue?vue&type=template&id=5e31093a&scoped=true"
import script from "./WorkbenchRichEditor.vue?vue&type=script&lang=js"
export * from "./WorkbenchRichEditor.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchRichEditor.vue?vue&type=style&index=0&id=5e31093a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31093a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e31093a')) {
      api.createRecord('5e31093a', component.options)
    } else {
      api.reload('5e31093a', component.options)
    }
    module.hot.accept("./WorkbenchRichEditor.vue?vue&type=template&id=5e31093a&scoped=true", function () {
      api.rerender('5e31093a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/components/WorkbenchRichEditor.vue"
export default component.exports